import { Config } from './../../App';

export function setUserId(setId: Function) {
    //@ts-ignore
    window.ya && window.ya(96713796, 'getClientID', function (clientID: number) { setId(clientID) })
}

export function getUserInfo(id: any, setUser: Function) {
    let link = 'https://rk.geosamara.ru/geosamara-demo-services/1.0.0/contact?metricID='
    link = link + id
    link = link.replace('@', "%")
    fetch(link)
        .then(response => response.json())
        .then(data => setUser(data));
}

export function sendMetricContacts(clientID: number, input: string, whereFrom: string, interested: string, callback?: Function) {
    let link = 'https://rk.geosamara.ru/geosamara-demo-services/1.0.0/contact?metricID='
    link = link + clientID + '&contact=' + encodeURIComponent(input);
    if (whereFrom && (whereFrom.length > 0)) {
        link += '&company=' + encodeURIComponent(whereFrom);
    }
    if (interested && (interested.length > 0)) {
        link += '&interested=' + encodeURIComponent(interested);
    }
    fetch(link, { method: 'POST', mode: "no-cors" })
        .then(r => {
            callback && callback();
            // console.log('Отправлено sendMetricContacts');
        })
}

export function sendMetricAction(clientID: number, action: string, info: string) {
    let link = 'https://rk.geosamara.ru/geosamara-demo-services/1.0.0/action?metricID='
    link = link + clientID + '&module=' + Config.metricModuleId + '&type=' + action + '&options[info]=' + info
    fetch(link, { method: 'POST', mode: "no-cors" })
        .then(r => {
            console.log('Отправлено sendMetricAction ', action);
        })
}



